import {Box, Button, Container, Drawer, Typography} from "@mui/material";
import {SearchTopBar} from "@/components/step1/search_bar/SearchTopBar";
import {useStyles} from "@/widget/SearchBarWidgetStyles";
import React, {useContext, useEffect, useState} from "react";
import {useResponsive} from "@/hooks/use-responsive";
import {useTranslation} from "react-i18next";
import {ISearchForm} from "@/interfaces/bookingContext";
import {toast} from "react-toastify";
import {g, gEventSearchArg, website} from "@/utils/helpers";
import {usePostSearch} from "@/api/availability";
import {SearchBarPopup} from "@/components/step1/search_bar/SearchBarPopup";
import {AppContext} from "@/utils/appContext";

const SearchBarWidget = () => {

  const { classes } = useStyles();
  const appContext = useContext(AppContext);
  const {t} = useTranslation();
  const [scrollPosition, setScrollPosition] = useState(0);
  const [drawerSearchState, setDrawerSearchState] = useState<boolean>(false);


  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const showSidebar = () => {
    setDrawerSearchState(true);
  };

  const hideSidebar = () => {
    setDrawerSearchState(false);
  };

  const sumGuests = () => {
    let count = 0;
    appContext.searchForms.forEach((sF: ISearchForm) => {
      count += sF.NoOfAdults;
      count += sF.ageOfChildren.length;
    });
    return count;
  };

  const sumPets = () => {
    let count = 0;
    appContext.searchForms.forEach((sF: ISearchForm) => {
      count += sF.Pets;
    });
    return count;
  };

  const setQuantity = (category: string, isIncrement: boolean, searchFormNum: number) => {

    // appContext.resetAvailability();

    const searchForm = [...appContext.searchForms];

    if (category === 'NoOfAdults') {
      if (isIncrement) {
        searchForm[searchFormNum][category] += 1;
      } else if (!isIncrement && searchForm[searchFormNum][category] > 1) {
        searchForm[searchFormNum][category] -= 1;
      }
    } else if (category === 'Children') {
      if (isIncrement) {
        searchForm[searchFormNum].ageOfChildren.push(-1);
      } else {
        searchForm[searchFormNum].ageOfChildren.pop();
      }
    }
    // searchForm[searchFormNum].status = 'to_start';
    appContext.setSearchForms([...searchForm]);
    sumGuests();
  };


  const setPets = (isIncrement: boolean, indexForm: number) => {
    //appContext.resetAvailability();
    const searchForm = [...appContext.searchForms];
    if (isIncrement && searchForm[indexForm]['Pets'] < 2) {
      searchForm[indexForm]['Pets'] += 1;
    } else if (!isIncrement && searchForm[indexForm]['Pets'] > 0) {
      searchForm[indexForm]['Pets'] -= 1;
    }
    appContext.setSearchForms([...searchForm]);
    sumPets();
  };

  const handleSubmit = async (event: { preventDefault: () => void }) => {
    event.preventDefault();
    if (
      appContext.searchForms[appContext.orderIndex].GuestArrival === null ||
      appContext.searchForms[appContext.orderIndex].GuestDeparture === null ||
      appContext.searchForms[appContext.orderIndex].GuestArrival === '' ||
      appContext.searchForms[appContext.orderIndex].GuestDeparture === ''
    ) {
      toast.warning(t('seleziona_date').toString());
    } else if (
      appContext.searchForms[appContext.orderIndex].GuestArrival === appContext.searchForms[appContext.orderIndex].GuestDeparture
    )  {
      toast.warning(t('date_arrivo_partenza_uguali').toString());
    } else if (
      appContext.searchForms[appContext.orderIndex].destination === '' &&
      appContext.searchForms[appContext.orderIndex].property === '' &&
      appContext.searchForms[appContext.orderIndex].landscape === ''
    ) {
      toast.warning(t('seleziona_destinazione').toString());
    } else if (
      appContext.searchForms[appContext.orderIndex].ageOfChildren.length > 0 &&
      appContext.searchForms[appContext.orderIndex].ageOfChildren.includes(-1)
    ) {
      toast.warning(t('selezionare_eta_dei_bambini').toString());
    } else {
      // appContext.searchForms[appContext.orderIndex].autoSearch = true;
      appContext.setSearchForms([...appContext.searchForms]);
      appContext.setBackdropIsOpen(true);

      let bookingURI = (website.code === 'VP') ? window.location.origin : 'https://huopenair.com';

      if (window.location.origin.includes('//test.') || (window.location.origin.includes('staging5') || (window.location.origin.includes('.dev'))) ) {
        bookingURI = 'https://test.huopenair.com'
      }

      if (appContext.language !== 'en') {
        bookingURI += `/${appContext.language}`;
      }

      console.log('bookingURI', bookingURI);

      try {
        const response = await usePostSearch(appContext.searchForms[appContext.orderIndex], appContext.userId, 'tokenRecaptcha');

        g('event', 'search_v2', gEventSearchArg(appContext.searchForms[appContext.orderIndex], appContext.userId));

        if (response.data.search_id) {
          if (appContext.searchForms[appContext.orderIndex].property && website.code !== 'VP') {
            appContext.setPropertySelected(appContext.searchForms[appContext.orderIndex].property);
          }

          bookingURI += `/booking-online#/search/${response.data.search_id}`;

          if(website.code === 'HU') {
            //Open results in self tab for huopenair.com
            window.location.href = bookingURI;
          } else {
            //Disable backdrop and open results in a new tab for micorsites
            setTimeout(() => {
              appContext.setBackdropIsOpen(false);
              window.open(bookingURI, '_blank');
            })
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        // appContext.setBackdropIsOpen(false);
        // setDrawerSearchState(false);
      }
    }
  };

  const upMd = useResponsive('up', 'md');
  const downMd = useResponsive('down', 'md');

  return (
    <Container maxWidth={false} className={scrollPosition < 200 ? classes.searchBarContainer : classes.searchBarContainerAfterScroll}>
      {
        upMd &&
        (
          <Box sx={{ maxWidth: '900px', margin: 'auto' }}>
            <Typography variant={'h4'} component={'h4'} className={ website.code !== 'HU' ? classes.noDestinationPicker : classes.destinationPicker}>{t(`searchbar_orizzontale_bol_${website.code}`)}</Typography>
            <SearchTopBar params={{ handleSubmit }} container={'SearchBarWidget'} />
          </Box>
        )
      }

      {
        downMd && (
          <>
            <Button
              color={'secondary'}
              id={'search'}
              variant={'contained'}
              onClick={() => showSidebar()}
              fullWidth
            >
                {t('Prenota ora')}
            </Button>
            <Drawer
            anchor={'right'}
            open={drawerSearchState}
            className={classes.root}
            disableScrollLock={true}
            disablePortal={true}
            onClose={() => {hideSidebar()}}>
              <SearchBarPopup params={{ setQuantity, setPets, setDrawerSearchState, handleSubmit, hideSidebar }} container={'DrawerSearchWidget'} />
            </Drawer>
          </>
        )
      }
    </Container>
  )
}

export default SearchBarWidget;
